import React from 'react'
import {
  extractHashtagsFromString,
  extractMentionsFromString
} from 'utils/DoorUtils'
import reactStringReplace from 'react-string-replace'
import { Link } from 'react-router-dom'
import Linkify from 'react-linkify'
import { Ogp } from 'apis/response_types'
import OgpView from 'components/door/room/Contents/elements/OgpView'

interface Props {
  content: string
  doorId: string
  ogps?: Array<Ogp>
}

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const addPrefixToEachString = (reg: string, arr: string[]): string => {
  return arr
    .map((word) => {
      return `${reg}${word}`
    })
    .join('|')
}

const removePrefix = (reg: string, word: string): string => {
  const removeReg = new RegExp(`^${reg}(.*)`)
  return word.replace(removeReg, '$1')
}

export default function LinkfiedContent(props: Props) {
  const style = { color: '#45B5F5' }
  const { content, doorId, ogps } = props
  const sortLength = (words: string[]): string[] => {
    return words.sort((a, b) => b.length - a.length)
  }

  return (
    <>
      {content.split('\n').map((text: string, i, arr) => {
        // ハッシュタグのリンク化
        let replaced
        const hashtagPrefixReg = '[#＃]'
        const hashtags = sortLength(extractHashtagsFromString(text))
        if (hashtags.length !== 0) {
          const hashtagReg = new RegExp(
            `(${addPrefixToEachString(hashtagPrefixReg, hashtags)})`,
            'g'
          )
          const path = `/room/${doorId}/search?type=hashtag`
          replaced = reactStringReplace(text, hashtagReg, (match) => (
            <Link
              key={match}
              to={`${path}&keyword=${removePrefix(
                hashtagPrefixReg,
                match
              )}`}
              rel="nofollow"
              style={style}
            >
              {match}
            </Link>
          ))
        }
        // メンションのリンク化
        const mentionPrefixReg = '[@＠]'
        const mentions = sortLength(extractMentionsFromString(text))
        if (mentions.length !== 0) {
          const mentionPattern = mentions.map((m) => escapeRegExp(m)).join('|')

          const mentionReg = new RegExp(
            `^(${mentionPrefixReg}(?:${mentionPattern}))`,
            'g'
          )

          replaced = reactStringReplace(
            replaced || text,
            mentionReg,
            (match, idx) => {
              return (
                <Link
                  key={idx}
                  to={`/door/${removePrefix(mentionPrefixReg, match)}`}
                  style={style}
                >
                  {match}
                </Link>
              )
            }
          )
        }

        return (
          <React.Fragment key={text.substring(0, 30) + i}>
            <Linkify
              componentDecorator={(decoratedHref, decoratedText) => (
                <>
                  <a
                    className={
                      /^mailto:/.test(decoratedHref)
                        ? 'disabled_email_link'
                        : ''
                    }
                    style={style}
                    rel="nofollow"
                    target="_blank"
                    href={decoratedHref}
                  >
                    {decoratedText.length > 50
                      ? decoratedText.substring(0, 50) + '...'
                      : decoratedText}
                  </a>
                  {
                    <OgpView
                      ogp={
                        ogps && ogps.find((ogp) => ogp.url === decoratedHref)
                      }
                    />
                  }
                </>
              )}
            >
              {replaced || text}
            </Linkify>
            {i !== arr.length - 1 && <br />}
          </React.Fragment>
        )
      })}
    </>
  )
}
